import { ErroApi } from "../api/cliente";

export function Carregando({ texto = "Carregando…" }: { texto?: string }) {
  return (
    <div className="carregando" role="status">
      {texto}
    </div>
  );
}

export function FalhaAoCarregar({ erro, tentarDeNovo }: { erro: unknown; tentarDeNovo?: () => void }) {
  const mensagem = erro instanceof ErroApi ? erro.message : "Não foi possível carregar.";
  return (
    <div className="aviso erro linha" role="alert">
      <span>{mensagem}</span>
      {tentarDeNovo && (
        <button className="btn pequeno fantasma" onClick={tentarDeNovo}>
          Tentar de novo
        </button>
      )}
    </div>
  );
}

/** Mensagem amigável para exibir em formulários/toasts a partir de qualquer erro. */
export function mensagemDeErro(erro: unknown): string {
  if (erro instanceof ErroApi) return erro.message;
  return "Erro inesperado. Tente de novo.";
}
